<template>
    <div class="condition-content">
        <compare-selector
            ref="selector"
            :value="currentValue"
            :valid="valid"
            type="GENDER"
            :placeholder="$t('请选择性别')"
            @change="onChange"
        />
    </div>
</template>

<script>
import CompareSelector from './plugins/compare-selector';

export default {
  name: 'Gender',

  components: {
    CompareSelector,
  },
  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Number,
      default: null,
    },
  },
  data() {
    const currentValue = this.value;
    return {
      currentValue,
      valid: true,
    };
  },
  computed: {
    brief() {
      const select = this.$refs.selector.currentOptions.find(item => item.value === this.currentValue);
      const selectText = select && select.text;
      return this.$t('{text}为{value}', { text: this.optionInfo.text, value: selectText });
    },
  },

  watch: {
    value(newValue) {
      this.currentValue = [0, 1, 2].includes(newValue) ? newValue : null;
    },
  },

  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    validate() {
      this.valid = typeof this.currentValue === 'number';
      return this.valid;
    },
    onChange(value) {
      this.valid = true;
      this.currentValue = value;
      const ruleData = {
        name: 'gender',
        type: 'array',
        operation: 'arrayInclude',
        value: JSON.stringify([value]),
      };
      const showVal = value;
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: typeof value === 'number',
      });
    },
  },
};
</script>
